var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddPatient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.711,
    height: 27.071,
    viewBox: "0 0 21.711 27.071",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "addPatient",
    transform: "translate(-506.152 -93.664)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_298",
    "data-name": "Path 298",
    d: "M515.228,108.918l-.832,1.435a2.28,2.28,0,0,1-1.231,1.013l-3.028,1.044a3.61,3.61,0,0,0-.41.127l-.048.018a3.943,3.943,0,0,0-2.513,3.707l-.517,4.415",
    fill: "none",
    stroke: "#6c5b7b",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_299",
    "data-name": "Path 299",
    d: "M518.787,108.918l.833,1.435a2.28,2.28,0,0,0,1.231,1.013l3.028,1.044a3.612,3.612,0,0,1,.41.127l.048.018a3.943,3.943,0,0,1,2.513,3.707l.517,4.415",
    fill: "none",
    stroke: "#6c5b7b",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_300",
    "data-name": "Path 300",
    d: "M512.255,101.705a13.8,13.8,0,0,0,1.674,5.96,3.565,3.565,0,0,0,6.149,0,11.916,11.916,0,0,0,1.469-5.693",
    fill: "none",
    stroke: "#6c5b7b",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_301",
    "data-name": "Path 301",
    d: "M520.392,96.419a4.852,4.852,0,0,0-7.156.187,5.07,5.07,0,0,0-1.132,4.27l.151.829a5.452,5.452,0,0,0,3.048-3.34",
    fill: "none",
    stroke: "#6c5b7b",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_302",
    "data-name": "Path 302",
    d: "M514.985,99.158c1.916,2.279,3.916.933,6.562,2.814",
    fill: "none",
    stroke: "#6c5b7b",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_303",
    "data-name": "Path 303",
    d: "M513.165,111.366l3.744,3.121,3.942-3.121",
    fill: "none",
    stroke: "#6c5b7b",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_304",
    "data-name": "Path 304",
    d: "M524.528,94.017l-3.522,3.522h3.522l-3.026,3.026",
    fill: "none",
    stroke: "#6c5b7b",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPatient);
export default __webpack_public_path__ + "static/media/addPatient.5b5042947eb50d6d203018062aa4d373.svg";
export { ForwardRef as ReactComponent };